import { createElement, FunctionComponent } from "react";
import { renderToStaticMarkup } from "react-dom/server";

const svgComponentToMarkupString = (Component: FunctionComponent): string =>
  `data:image/svg+xml,${encodeURIComponent(
    renderToStaticMarkup(createElement(Component))
  )}`;

export default svgComponentToMarkupString;
